import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/Inventory",
    name: "Inventory",
    component: () => import("@/views/InventoryWeb.vue"),
  },
  {
    path: "/test",
    name: "Orders",
    component: () => import("@/views/OrdersWeb.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginForm.vue"),
  },
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
  },
  {
    path: "/Orders",
    name: "Transfer",
    component: () => import("@/views/TransferRequest.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
